export const FORMAT_TIME = {
  DATE1: 'DD [Th]M, YYYY',
}